const RELATIONSHIP_SELECT_OPTIONS = [
    { value: "Spouse", label: "Spouse" },
    { value: "FormerSpouse", label: "Former Spouse" },
    { value: "Child", label: "Child" },
    { value: "Sibling", label: "Sibling" },
    { value: "Father", label: "Father" },
    { value: "Mother", label: "Mother" },
    { value: "Grandchild", label: "Grandchild" },
    { value: "Fiancee", label: "Fiancee" },
    { value: "Nephew", label: "Nephew" },
    { value: "Niece", label: "Niece" },
    { value: "DomesticPartner", label: "Domestic Partner" },
    { value: "Aunt", label: "Aunt" },
    { value: "Uncle", label: "Uncle" },
    { value: "Cousin", label: "Cousin" },
    { value: "BusinessAssociate", label: "Business associate" },
];

export default RELATIONSHIP_SELECT_OPTIONS;
